module.exports = __webpack_public_path__ + "static/img/SaaSfrimg.73feeb1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/SaaSfrimg.png
// module id = W2AI
// module chunks = 1